import Vue from "vue";
import { Component } from 'vue-facing-decorator';

@Component
export default class PageBase extends Vue {
    get tid(): number { return parseInt(this.$route.params.tid); }
    get wid(): number { return parseInt(this.$route.params.wid); }
    get pid(): number { return parseInt(this.$route.params.pid); }
    get id(): string { return this.$route.params.id; }

    setTitle(title: string) {
        document.title = title;
    }

    navigateTo(url: string) {
        location.href = url;
    }
}